<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 24 24"
    enable-background="new 0 0 24 24"
    xml:space="preserve">
    <g id="Black">
      <g>
        <g>
          <rect
            x="10.439"
            y="17.939"
            transform="matrix(0.7071 -0.7071 0.7071 0.7071 -10.0668 13.6967)"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            width="2.121"
            height="2.121" />
          <polygon
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            points="12,15.5      11,15.5 10,9.5 13,9.5    " />
        </g>
        <polygon
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          points="0.5,23.5     22.5,23.5 11.47,1.5   " />
      </g>
    </g>
  </svg>
</template>
